export class CardModel {
    public id: number;
    public number: string;
    public first_digits: string;
    public last_digits: string;
    public holder_name: string;
    public cvc: string;
    public brand: string;
    public expiration_date: string;
    public must_be_tokenized: boolean;

    public parseJson(json: any) {
        if (json.id !== undefined) {
            this.id = json.id;
        }
        if (json.first_digits !== undefined) {
            this.first_digits = json.first_digits;
        }
        if (json.last_digits !== undefined) {
            this.last_digits = json.last_digits;
        }
        if (json.holder_name !== undefined) {
            this.holder_name = json.holder_name;
        }
        if (json.brand !== undefined) {
            this.brand = json.brand;
        }
        if (json.expiration_date !== undefined) {
            this.expiration_date = json.expiration_date;
        }
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2645790472/src/src/app/shared/models/card.model.ts